<template>
  <div class="page-home-header"
       :class="[
         `type-${type}`
       ]"
       v-if="showTitle || showBanner"
  >
    <div class="header-title-container"
         :class="[
           { 'is-show-title': showTitle },
         ]"
    >
      <ym-vip-entrance v-if="showVipEntrance"
                       class="header-vip-entrance"
      />
      <ym-search v-if="search"
                 class="header-search"
                 :placeholder="search.placeholder"
                 @focus="handleFocusSearch"
      />
      <ym-player status="mini" />
    </div>
    <div class="banner"
         v-if="showBanner"
    >
      <ym-banner :banner="banner"
                 :record-name="recordName"
                 @click="handleClickBanner"
      />
    </div>

    <div class="page-home-header-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import VipCenterEntrance from '@/components/VipCenterEntrance';
  import SearchBar from '@/components/Search/Bar';
  import Player from '@/components/Player';
  import Banner from '@/components/Banner';
  import validator from '@/utils/validator';

  export default {
    name: 'HomeHeaderBlock',
    components: {
      'ym-vip-entrance': VipCenterEntrance,
      'ym-search': SearchBar,
      'ym-player': Player,
      'ym-banner': Banner,
    },
    props: {
      search: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      showVipEntrance: {
        type: Boolean,
        default: false,
      },
      showPlayingBtn: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      banner: {
        type: Array,
        default() {
          return [];
        },
      },
      type: {
        type: String,
        default: 'white',
        validator(val) {
          return [
            'white',
            'gray',
          ].includes(val);
        },
      },
      recordType: {
        type: String,
        validator(val) {
          return [
            'main',
            'audio',
            'course',
            'parent',
          ].includes(val);
        },
      },
    },
    computed: {
      showTitle() {
        return this.title !== '';
      },
      showBanner() {
        return this.banner.length > 0;
      },
      recordName() {
        const { recordType } = this;
        return recordType ? `${recordType}_BANNER`.toUpperCase() : null;
      },
    },
    methods: {
      handleClickBanner(item) {
        this.$emit('click-banner', item);
      },
      handleFocusSearch() {
        const { search } = this;
        const { type: product } = search;
        const route = { name: 'Search', query: { product } };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @page-header-padding-left: @size-base;
  .page-home-header {
    padding: @size-base 0 0;
    &.type-white {
      background-color: @color-white;
    }
    &.type-gray {
      background-color: @color-gray-lightest;
    }
  }

  .header-title-container {
    overflow: hidden;
    padding: 0 @page-header-padding-left;
    margin-bottom: @size-medium;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-vip-entrance {
    margin-right: @size-base;
  }

  .banner {
    padding-left: @page-header-padding-left;
    margin-bottom: -@banner-shadow-bottom;
  }

  .is-show-title + .banner {
    margin-top: @size-base;
  }

  .page-home-header-content {
    width: 100%;
    overflow: hidden;
  }
</style>
